import styled from 'styled-components'

export const ChartContainer = styled.div`
    margin-bottom: var(--dashboard-default-gap);
    .recharts-tooltip-wrapper {
        outline: none;
    }
`
export const TooltipContainer = styled.div`
    background-color: var(--dashboard-basic-background-color);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    padding: 10px;
    transform: translateY(-100px);
    h5 {
        margin: 10px 0;
        font-size: 16px;
        font-weight: 500;
        color: var(--dashboard-main-color);
    }
    ul {
        padding: 0;
        margin: 0;
        display: flex;
        align-items: center;
        justify-content: space-around;
        li {
            list-style: none;
            padding: 6px;
            border-right: var(--dashboard-default-border-thin);
            text-align: center;
            b {
                display: block;
                font-size: 12px;
                font-weight: normal;
                color: var(--dashboard-secondary-color);
            }
            strong {
                font-size: 16px;
                line-height: 16px;
            }
            &:last-child {
                border-right: none;
            }
        }
    }
`
